import WORKOUT_EXERCISES_KEY from './key'

const WORKOUT_EXERCISES_STATE = {
  [WORKOUT_EXERCISES_KEY.ALL]: {
    data: [],
    status: null
  },
  [WORKOUT_EXERCISES_KEY.CURRENT]: null,
  [WORKOUT_EXERCISES_KEY.CURRENT_SET_INDEX]: null,
  [WORKOUT_EXERCISES_KEY.DATA]: {}
}

export default WORKOUT_EXERCISES_STATE
